export enum ScreenNames {
  PASSKEY_ENROLLMENT_AFTER_SIGNUP = 'Passkey enrollment after signup',
  LOGIN_PAGE = 'Login page',
  SIGNUP_PAGE = 'Signup page',
  PASSWORD_OTP_LOGIN = 'Password/OTP login',
  VERIFY_OTP = 'Verify OTP',
  VERIFY_OTP_SIGNUP = 'Verify OTP(signup)',
  VERIFY_SMS_OTP = 'Verify SMS OTP',
  PHONE_LOGIN_SCREEN = 'Phone Login Screen',
  CHOOSE_USERNAME_EMAIL_OTP = 'Choose username(email otp signup)',
  SOCIAL_SIGNUP_USERNAME = 'Social signup username',
  CONFIRM_EMAIL = 'Confirm Email',
  ARKOSE_LOGIN_GATE = 'Arkose gate before login routing',
  ARKOSE_SIGNUP_GATE = 'Arkose gate before signup email validation',
  ARKOSE_SMS_LOGIN_GATE = 'Arkose gate before SMS login',
  ARKOSE_SMS_SIGNUP_GATE = 'Arkose gate before SMS signup',
}

// Screen ID mappings from Descope flow
export const SCREEN_IDS = {
  PASSKEY_ENROLLMENT_AFTER_SIGNUP: 'SC2lNgZ5DJbHOEJmA9ei7mfML3Fn',
  LOGIN_PAGE: 'SC2zCxHiAVIm39a4aJ4CAGU9VIfR6',
  PASSWORD_OTP_LOGIN: 'SC31Zn6OObRWOKR0PjTBRDQOuurd1',
  VERIFY_OTP_LOGIN: 'SC31ZhH2z7588yMna3opp1w1es9Hs',
  SIGNUP_PAGE: 'SC31cTy5s1jPy4xB6KuosIp5hHri8',
  CHOOSE_USERNAME_EMAIL_OTP: 'SC32GXhGyRZF1NAN2kY0mYZScVa1f',
  VERIFY_OTP_SIGNUP: 'SC32GZnrA1Hw7DQ6SpdSL7WK7uSLs',
  VERIFY_SMS_OTP: 'SC3EZ50YYNf6s9I6UMYW7LLvnlrvK',
  PHONE_LOGIN_SCREEN: 'SC3EZ5tQIn5mwbpoHFg1uD0FUm5NV',
  SOCIAL_SIGNUP_USERNAME: 'SC32OU3hxKlEMFayZhZpkfPjrw5VR',
  CONFIRM_EMAIL: 'SC3FcDQaLwGZHFYZY5KQkujMhai79',
  ARKOSE_LOGIN_GATE: 'SC3ArkoseLoginGate7wN2pX9QaZ4',
  ARKOSE_SIGNUP_GATE: 'SC3ArkoseSignupGate8xM4qY7RbK',
  ARKOSE_SMS_LOGIN_GATE: 'SC3ArkoseSmsLoginGate9uP2dK6LmN',
  ARKOSE_SMS_SIGNUP_GATE: 'SC3ArkoseSmsSignupGate6hR4nB8VxQ',
};

export const PASSKEY_INTERACTION_IDS = {
  LOGIN: 'passkey-login',
  ENROLL: 'NBlRNCDAZS',
  SKIP_ENROLLMENT: '-elJaMwrLU',
} as const;
